const DELETE_CONFIRMATION = {
	HEADING: 'Are you sure you want to delete all selected videos?',
	CANCEL: 'Cancel',
	DELETE: 'Delete',
};

export default DELETE_CONFIRMATION;
